import YTablePro from './src'

YTablePro.install = function(Vue) {
  Vue.component(YTablePro.name, YTablePro)
}

export default YTablePro
